// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"193":"9477d09a","521":"707d6514","559":"76c87ad4","968":"8d88a3aa"}[chunkId] + ".css";
};